@if (initialized && dto) {
    @if (activeNavigationItems?.action == 'payFrequency') {
        @if (widgetPayFrequency) {
            <mvs-widget
                    [widgetData]="widgetPayFrequency"
            ></mvs-widget>
        }
    }
    @if (activeNavigationItems?.action == 'templateCalculationBase') {
        @if (widgetTemplateCalculationBase) {
            <mvs-widget
                    [widgetData]="widgetTemplateCalculationBase"
            ></mvs-widget>
        }
    }
    @if (activeNavigationItems?.action == 'templateLiability') {
        @if (widgetTemplateLiability) {
            <mvs-widget
                    [widgetData]="widgetTemplateLiability"
            ></mvs-widget>
        }
    }
}
